import { colors } from '@yorukiri/ui/tokens';

export type SegmentState = 'pending' | 'ok' | 'hard' | 'again' | 'current';

const segColor: Record<SegmentState, string> = {
  pending: colors.line,
  ok: colors.good,
  hard: colors.warn,
  again: colors.accent,
  current: colors.ink,
};

export function ProgressSegments({
  segments,
  position,
  total,
  togo,
}: {
  segments: SegmentState[];
  position: number;
  total: number;
  togo: number;
}) {
  return (
    <div
      style={{
        padding: '18px 24px 6px',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'grid',
          gridTemplateColumns: `repeat(${segments.length}, 1fr)`,
          gap: 3,
          height: 5,
        }}
      >
        {segments.map((s, i) => (
          <span
            key={i}
            style={{
              background: segColor[s],
              borderRadius: 1.5,
              outline: s === 'current' ? `1.5px solid ${colors.accent}` : 'none',
              outlineOffset: 2,
            }}
          />
        ))}
      </div>
      <span
        style={{
          fontVariantNumeric: 'tabular-nums',
          fontSize: 11,
          color: colors.ink3,
          letterSpacing: '0.06em',
        }}
      >
        <b style={{ color: colors.ink, fontWeight: 500 }}>{position}</b> / {total} · {togo} to go
      </span>
    </div>
  );
}
